export default [
  {
    title: 'Rental Order',
    key: 'rentalorders',
    url: '/rental/orders',
    icon: 'icmn icmn-cart',
    children: [
      {
        title: 'Rental List',
        key: 'rentalorderlist',
        url: '/rental/orders',
      },
      {
        title: 'List Over Due',
        key: 'overdueorders',
        url: '/rental/overdueorders',
      },
    ],
  },
  {
    title: 'Customer',
    key: 'customer',
    url: '/customers',
    icon: 'icmn icmn-home',
  },
  {
    title: 'Promotion',
    key: 'promotion',
    url: '/promotion',
    icon: 'icmn icmn-home',
  },
  {
    title: 'Device Buy Order',
    key: 'devicebuyorder',
    url: '/devicebuyorders',
    icon: 'icmn icmn-home',
  },
  {
    title: 'Sim Card Buy Order',
    key: 'simbuyorders',
    url: '/simbuyorders',
    icon: 'icmn icmn-home',
  },
  {
    title: 'Manage Products',
    key: 'products',
    url: '/products',
    icon: 'icmn icmn-home',
  },
  {
    title: 'Manage Admins',
    key: 'admins',
    url: '/admins',
    icon: 'icmn icmn-home',
  },
]



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Menu/MenuTop/menuData.js